module.exports = __webpack_public_path__ + "static/BBIS-Towels-min-e21e4d77a391adbfbc6723219334ba35.jpg";